var module = angular.module('octopusApp.projects');

module.controller('ProjectVariablesIncludeController', function ($scope, busy, octopusRepository, current, $uibModalInstance, contentType, contentTypeDesc) {
  var isLoading = $scope.isLoading = busy.create();
  $scope.contentTypeDesc = contentTypeDesc;

  isLoading.promise(octopusRepository.LibraryVariableSets.all({contentType: contentType}).then(function(all){
    $scope.libraryVariableSets = [];
    _.each(all, function(lvs){
      $scope.libraryVariableSets.push({
        id: lvs.Id,
        title: lvs.Name,
        description: lvs.Description,
        isIncluded: _.contains(current, lvs.Id)
      });
    });
  }));

  $scope.close = function() {
    $uibModalInstance.close();
  };

  $scope.save = function () {
    var thisType = _.filter($scope.libraryVariableSets, function(lvs) {
      return lvs.isIncluded;
    });

    var thisTypeIds = _.pluck(thisType, 'id');

    var otherIds = _.filter(current, function(c){
      return !_.find($scope.libraryVariableSets, function(lvs) { return lvs.id === c; });
    });

    var ids = _.union(thisTypeIds, otherIds);

    $uibModalInstance.close(ids);
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_variables_include_controller.js
// module id = 4619506918498556
// module chunks = 1